import { render, staticRenderFns } from "./NewsVideoTwo.vue?vue&type=template&id=7e364626&scoped=true"
import script from "./NewsVideoTwo.vue?vue&type=script&lang=js"
export * from "./NewsVideoTwo.vue?vue&type=script&lang=js"
import style0 from "./NewsVideoTwo.vue?vue&type=style&index=0&id=7e364626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e364626",
  null
  
)

export default component.exports